<div class="relative flex flex-auto lg:flex-row mdMax:flex-col">
  @if (isMobile$ | async) {
    <div
      class="absolute flex w-full items-center justify-center gap-x-2 px-4 py-3"
      style="z-index: 1"
    >
      <div class="min-w-0 flex-1 flex flex-col">
        <app-input-text-atom
          [label]="textInputLabel | translate"
          [iconRight]="textInputIcon"
          [cross]="true"
          [value]="(filterAddress$ | async) ?? ''"
          (iconClick)="getCurrentPosition()"
          (valueChange)="onClear($event)"
        >
        </app-input-text-atom>
        @if (geolocateError?.length) {
          <div class="mt-2 rounded bg-white py-2 text-center font-base text-sm text-error-700">
            {{ geolocateError }}
          </div>
        }
      </div>
      <app-rounded-icon-button
        [icon]="filterIcon"
        (onClick)="openFiltersModal()"
      ></app-rounded-icon-button>
      <!-- <app-rounded-icon-button [icon]='searchIcon'></app-rounded-icon-button> -->
    </div>
  }

  @if (!(isMobile$ | async)) {
    <div class="flex min-w-1/4 max-w-3/7 flex-col overflow-y-auto p-6">
      <div class="flex gap-3">
        @if (!(isMobile$ | async)) {
          <app-button-atom
            [type]="'light'"
            [icon]="filterIcon"
            [label]="filterButtonLabel | translate"
            (clickEventEmitter)="openFiltersModal()"
          >
          </app-button-atom>
        }
        <!-- <app-rounded-icon-button [icon]='searchIcon'></app-rounded-icon-button> -->
      </div>
      <h1 class="leading-8.5 pb-4 pt-5 font-accent text-28px font-bold">
        {{ 'shop-list-header.title' | translate }}
      </h1>
      <div class="flex max-h-45-screen flex-col divide-y divide-neutral-300">
        @for (shop of shops; track shop.id) {
          <div
            class="py-3 first:pt-0"
            (click)="navigateToShopPage(shop)"
          >
            <app-push-shop-atom
              [name]="shop[entityKeys.Name]"
              [category]="shop[entityKeys.Type]?.name ?? ''"
              [distance]="shop[entityKeys.Distance]"
              [budget]="shop.pricing"
              [shop]="shop"
            >
            </app-push-shop-atom>
          </div>
        }
        @if (isGetShopLoading && !shops.length) {
          @for (j of [].constructor(8); track $index) {
            <div class="flex">
              <div class="my-2 mr-2 h-24 w-24 animate-pulse rounded bg-neutral-300"></div>
              <div class="my-2 w-2/4">
                <p class="mb-2 h-4 w-full animate-pulse bg-neutral-400"></p>
                <p class="mb-2 h-3 w-3/4 animate-pulse bg-neutral-300"></p>
                <p class="mb-2 h-2 w-1/4 animate-pulse bg-neutral-300"></p>
              </div>
            </div>
          }
        }
      </div>
    </div>
  }

  <div class="flex-auto">
    @if (isMapApiLoaded) {
      <google-map
        width="100%"
        height="100%"
        class="h-full"
        [options]="mapOptions"
      >
        @if (currentMarkerPosition) {
          <map-marker
            [icon]="currentMarkerIcon"
            [position]="currentMarkerPosition"
          ></map-marker>
        }
        @if (selectedMarkerPosition) {
          <map-marker
            [icon]="selectedMarkerIcon"
            [options]="selectedMarkerOptions"
            [position]="selectedMarkerPosition"
          ></map-marker>
        }
        <deprecated-map-marker-clusterer
          [styles]="clusterStyles"
          [maxZoom]="clusterMaxZoom"
          [imagePath]="clusterImagePath"
          [minimumClusterSize]="clusterMinimumSize"
        >
          @for (marker of markers; track marker.lat + '_' + marker.lng) {
            @if (isMarkerVisible(marker)) {
              <map-marker
                [position]="marker"
                [icon]="neutralMarkerConfig"
                (mapClick)="selectMarker($event)"
              ></map-marker>
            }
          }
        </deprecated-map-marker-clusterer>
      </google-map>
    }
  </div>

  <div class="sticky bottom-10 flex flex-col">
    <div
      class="absolute right-0 flex flex-row-reverse p-4"
      [ngClass]="isShopSideScrollingListVisible && (isMobile$ | async) ? 'bottom-28' : 'bottom-4'"
    >
      @if (isMobile$ | async) {
        <app-rounded-icon-button
          type="normal"
          [icon]="bulletListIcon"
          (onClick)="navigateToShopList()"
        >
        </app-rounded-icon-button>
      }
      @if (!(isMobile$ | async)) {
        <app-button-atom
          class="shrink-0"
          [type]="'primary'"
          [icon]="bulletListIcon"
          [label]="bulletListButtonLabel | translate"
          (clickEventEmitter)="navigateToShopList()"
        >
        </app-button-atom>
      }
    </div>

    @if (shops.length && isShopSideScrollingListVisible && (isMobile$ | async)) {
      <div
        #shopSideScrollingList
        class="absolute bottom-4 flex w-full snap-x gap-2 overflow-x-auto"
      >
        @for (shop of shops; track shop.id) {
          <div
            class="inline-block h-24 w-11/12 shrink-0 snap-center rounded first:pl-5 last:pr-5"
            (click)="navigateToShopPage(shop)"
          >
            <app-push-shop-atom
              [name]="shop[entityKeys.Name]"
              [category]="shop[entityKeys.Type]?.name ?? ''"
              [distance]="shop[entityKeys.Distance]"
              [budget]="shop.pricing"
              [shop]="shop"
            >
            </app-push-shop-atom>
          </div>
        }
      </div>
    }
  </div>

  <div class="sticky bottom-0 lg:hidden">
    <app-shop-search-parameters-overview></app-shop-search-parameters-overview>
  </div>
</div>
